module.exports = __webpack_public_path__ + "img/codigoqr.c9f0f871.png";